( function () {
	const BLOCK_SELECTOR = '.sp-articles-carousel-block';
	const SLIDER_SELECTOR = `${ BLOCK_SELECTOR } .category-posts-sliders`;
	const SPLIDE_CDN_URL =
		'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

	function loadScriptOnce( src ) {
		return new Promise( ( resolve, reject ) => {
			if ( document.querySelector( `script[src="${ src }"]` ) ) {
				resolve();
				return;
			}
			const script = document.createElement( 'script' );
			script.src = src;
			script.onload = () => resolve();
			script.onerror = () => reject( new Error( `Failed to load script: ${ src }` ) );
			document.head.appendChild( script );
		} );
	}

	function init() {
		const blocks = document.querySelectorAll( BLOCK_SELECTOR );
		if ( ! blocks.length ) return;

		loadScriptOnce( SPLIDE_CDN_URL )
			.then( () => {
				document.querySelectorAll( SLIDER_SELECTOR ).forEach( el => {
					if ( el.classList.contains( 'is-initialized' ) ) return;

					const isStaticPage = !!el.closest( '.static-pages-container' );

					// For static pages, override to show 3 articles per view.
					if ( isStaticPage ) {
						const currentConfig = el.getAttribute( 'data-splide' );
						const staticConfig = {
							perPage: 3,
							perMove: 1,
							breakpoints: {
								1440: { perPage: 3 },
								720: { perPage: 2 },
								540: { perPage: 1 },
							},
						};

						// Merge any existing config with our static overrides
						let baseConfig = {};
						if ( currentConfig ) {
							try {
								baseConfig = JSON.parse( currentConfig );
							} catch ( e ) {
								baseConfig = {};
							}
						}
						el.setAttribute(
							'data-splide',
							JSON.stringify( {
								...baseConfig,
								...staticConfig,
							} )
						);
					}

					// Reuse the theme's Splide initializer when available (keeps behaviour identical)
					if ( typeof window.initializeSplide === 'function' ) {
						window.initializeSplide( el );
						return;
					}

					// Fallback init (should be rare if global initializer is loaded)
					// eslint-disable-next-line no-undef
					const baseConfig = {
						type: 'slide',
						perPage: 5,
						perMove: 1,
						speed: 1000,
						autoHeight: false,
						gap: '8px',
						pagination: false,
						breakpoints: {
							1440: { perPage: 4 },
							720: { perPage: 3 },
							540: { perPage: 1 },
						},
					};

					const staticOverrides = isStaticPage
						? {
								perPage: 3,
								breakpoints: {
									1440: { perPage: 3 },
									720: { perPage: 2 },
									540: { perPage: 1 },
								},
						  }
						: {};

					const splide = new Splide( el, {
						...baseConfig,
						...staticOverrides,
					} );

					splide.on( 'mounted', () => {
						el.classList.add( 'is-initialized' );
						splide.refresh();
					} );
					splide.mount();
				} );
			} )
			.catch( err => console.error( 'Error loading Splide:', err ) );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();

